import './App.css';
import AppContainer from './views/containers';
import AdminPage from './views/admin/AdminPage';

function App() {
  if (window.location.pathname === '/admin') return <AdminPage />;
  return <AppContainer />;
}

export default App;
